/**
 * sl-m82f.4.1: Reusable 3-column summary card grid used by every feature
 * tab. Kept here (not inside `./tabs/`) so all tabs import the same
 * component — DRY.
 */
import type { CSSProperties } from 'react';

import {
  summaryCard,
  summaryGrid,
  summaryLabel,
  summarySubtext,
  summaryValue,
  summaryValueSmall,
} from './styles';

export interface SummaryCardData {
  label: string;
  value: string;
  subtext?: string;
  /** Force the value into the smaller font (for long strings / names). */
  smallValue?: boolean;
}

export interface TabSummaryCardsProps {
  cards: readonly SummaryCardData[];
}

/**
 * Summary cards laid out in a flex grid. Variable length (1-N). Tabs that
 * have only "total credits + count" render two cards; tabs with a "Top X"
 * highlight render three.
 */
export const TabSummaryCards = ({ cards }: TabSummaryCardsProps) => {
  return (
    <div style={summaryGrid}>
      {cards.map((card, index) => {
        const valueStyle: CSSProperties = card.smallValue
          ? summaryValueSmall
          : summaryValue;
        return (
          <div key={index} style={summaryCard}>
            <p style={summaryLabel}>{card.label}</p>
            <p style={valueStyle}>{card.value}</p>
            {card.subtext && <p style={summarySubtext}>{card.subtext}</p>}
          </div>
        );
      })}
    </div>
  );
};
